import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

type BUTTON_TYPE = 'outline' | 'solid';

@Component({
  selector: 'par-button',
  templateUrl: './par-button.component.html',
  styleUrls: ['./par-button.component.scss']
})
export class ParButtonComponent {
  @Input()  buttonType: string = 'submit';
  @Input() buttonText: string = 'PAR Button';
  @Input() disabled: boolean = false;
  @Input() buttonDesign: BUTTON_TYPE = 'solid';
  @Output() btnClick = new EventEmitter();

  buttonClick() {
    this.btnClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/par-library/form-components/par-button/par-button.component.ts